const stars = document.querySelectorAll(".rating-stars .star");
const ratingValue = document.getElementById("rating-value");

const ratingElement = document.getElementById("rating");
const colorFilled = ratingElement.dataset.colorFilled || "#f39c12";
const colorEmpty = ratingElement.dataset.colorEmpty || "#cccccc";

console.log("Filled color:", colorFilled);
console.log("Empty color:", colorEmpty);

stars.forEach((star, idx) => {
  star.addEventListener("click", function () {
    const selectedRating = parseInt(star.dataset.starIndex);
    ratingValue.value = selectedRating;

    stars.forEach((s, i) => {
      const gradientId = `custom-reviews-card-svg-gradient-${i + 1}`;
      const gradient = document.getElementById(gradientId);
      if (!gradient) return;

      const stops = gradient.querySelectorAll("stop");
      const isFilled = i < selectedRating;

      stops[0].setAttribute("stop-color", isFilled ? colorFilled : colorEmpty);
      stops[1].setAttribute("stop-color", isFilled ? colorFilled : colorEmpty);
    });
  });
});

document.getElementById("review-form").addEventListener("submit", function (e) {
  e.preventDefault();

  Spinner.show();

  const form = e.target;
  const email = document.getElementById("email").value.trim();
  const emailError = document.getElementById("email-error");

  // Basic email validation
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  if (!emailRegex.test(email)) {
    emailError.style.display = "inline";
    return; // Stop submission
  } else {
    emailError.style.display = "none";
  }

  const formData = new FormData(form);

  fetch(form.action, {
    method: "POST",
    body: formData,
    headers: {
      Accept: "text/html",
    },
  })
    .then((response) => response.text())
    .then((data) => {
      // Show a success message
      //alert('Form submitted successfully.');
      console.log("Form submitted successfully.");
      Spinner.hide();
      form.reset();
    })
    .catch((error) => {
      console.error("Submission error:", error);
      alert("There was an error submitting the form.");
    });
});
